import { ActionLogEntityType } from '@mews-commander/types';
import { getNowUtc } from '@mews-commander/utils';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { logActionLogInit } from '@mews-commander/legacy-entities/src/actions/actionLogs';
import { getOrderItem } from '@mews-commander/legacy-entities/src/ducks';
import {
    fetchAccountsByIds,
    fetchActionLogItems,
    fetchCurrentEnterpriseBillsByAccountIds,
    fetchCurrentEnterpriseBillsByIds,
    fetchServiceOrders,
} from '@mews-commander/legacy-entities/src/actions';
import { DEFAULT_BILL_FETCH_EXTENT } from '@mews-commander/legacy-entities/src/actions/bills';
import { getActionLogItemsByEntityOrOwnerId } from '@mews-commander/legacy-entities/src/ducks/actionLogItems';
import { ORDER_ITEM_EXTENT } from '../../constants';
import { getUtcTimeOneSecondEarlierFromUtcDate } from '../../utils';
import { fetchOrderItems } from '../../../billing/actions/orderItems';

const BILLING_EXTENT = {
    orderItems: true,
    services: true,
    products: true,
};

const ACCOUNTS_EXTENT = {
    profiles: true,
    users: true,
    relatedCustomers: true,
};
// @ts-expect-error removed universal router RouteLeaf['fetchDependency']
const initializeOrderItemActionLog = async ({ dispatch, getState }, { id: orderItemId }) => {
    const startTime = window.performance.now();
    await dispatch(fetchOrderItems({ orderItemIds: [orderItemId as string], extent: ORDER_ITEM_EXTENT }));

    const state = getState();
    const orderItem = getOrderItem(state, { id: orderItemId as string });
    const enterpriseId = getCurrentEnterpriseId();

    if (!orderItem) throw new Error(`Order item with id ${orderItemId as string} not found`);

    const createdUtc = {
        startUtc: getUtcTimeOneSecondEarlierFromUtcDate(state, { utc: orderItem.createdUtc }),
        endUtc: getNowUtc(),
    };

    const entityFilters = [
        {
            ownerIds: [orderItemId as string],
            entityTypeNames: [ActionLogEntityType.OrderItem],
        },
        {
            entityIds: [orderItemId as string],
            entityTypeNames: [ActionLogEntityType.OrderItem],
        },
    ];

    const actionLogItemsPromise = entityFilters.map((entityFilter) =>
        dispatch(fetchActionLogItems({ enterpriseIds: [enterpriseId], createdUtc, entityFilters: [entityFilter] }))
    );

    await Promise.all(actionLogItemsPromise);

    const orderItemIds = getActionLogItemsByEntityOrOwnerId(getState(), { entityId: orderItem.id }).map(
        ({ entityId }) => entityId
    );

    const orderItemsPromise = dispatch(fetchOrderItems({ orderItemIds }));

    const serviceOrdersPromise = dispatch(fetchServiceOrders({ serviceOrderIds: [orderItem.serviceOrderId] }));

    const billPromise = orderItem.billId
        ? dispatch(
              fetchCurrentEnterpriseBillsByIds({
                  billIds: [orderItem.billId],
                  extent: { ...DEFAULT_BILL_FETCH_EXTENT, ...BILLING_EXTENT },
              })
          )
        : dispatch(
              fetchCurrentEnterpriseBillsByAccountIds({
                  accountIds: [orderItem.ownerId],
                  extent: { ...DEFAULT_BILL_FETCH_EXTENT, ...BILLING_EXTENT },
              })
          );
    const accountPromise = dispatch(
        fetchAccountsByIds({
            accountIds: [orderItem.ownerId],
            extent: ACCOUNTS_EXTENT,
        })
    );

    return Promise.all([billPromise, accountPromise, serviceOrdersPromise, orderItemsPromise]).then(() =>
        dispatch(
            logActionLogInit({ entityId: orderItemId as string, entityType: ActionLogEntityType.OrderItem, startTime })
        )
    );
};

export default initializeOrderItemActionLog;
